/* eslint-disable import/no-cycle */
// Store functionality
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  count: 1,
  next: null,
  previous: null,
  follower: [],
};

const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
